import { render, staticRenderFns } from "./DescontosPainel.vue?vue&type=template&id=f3b33924&scoped=true"
import script from "./DescontosPainel.vue?vue&type=script&lang=js"
export * from "./DescontosPainel.vue?vue&type=script&lang=js"
import style0 from "./DescontosPainel.vue?vue&type=style&index=0&id=f3b33924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b33924",
  null
  
)

export default component.exports